import useLocalStorage from '@/hooks/use-local-storage';
import {
  Box,
  IconButton,
  useDisclosure,
  Text,
  Icon,
  Flex,
  Button,
  BoxProps,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { BsClock } from 'react-icons/bs';
import { MdClose } from 'react-icons/md';

const MBox = motion<BoxProps>(Box);

const SurveyPopup = () => {
  const [surveyStatus, setSurveyStatus] = useLocalStorage<
    'not-displayed' | 'displayed' | 'action-done'
  >(`survey-status`, `not-displayed`);

  const { isOpen, onClose, onOpen } = useDisclosure({
    defaultIsOpen: false,
    onClose: () => setSurveyStatus(`action-done`),
  });
  useEffect(() => {
    if (surveyStatus !== `action-done`) {
      setTimeout(onOpen, 30 * 1000);
    }
  }, []);
  return (
    <MBox
      initial={{ x: 420 }}
      animate={{ x: !isOpen ? 420 : 0 }}
      position="fixed"
      borderStartRadius="xl"
      bgColor="#f0f0f0"
      zIndex="toast"
      top="150px"
      right="0"
      w={[`xs`, null, `sm`]}
    >
      <Box py="5" position="relative" pe={9} ps={16}>
        <IconButton
          size="sm"
          aria-label="close"
          icon={<Icon boxSize="5" as={MdClose} />}
          position="absolute"
          top="4"
          left="3"
          onClick={onClose}
        />
        <Text fontWeight="bold" color="brand.500" fontSize="xl">
          ANKET
        </Text>
        <Text mt="2">Fikirlerinizi bizimle Paylasmak ister misiniz?</Text>
        <Flex
          align="center"
          justify="start"
          fontSize={[`xs`, null, `md`]}
          mt="3"
          color="gray.500"
        >
          <Icon as={BsClock} h="4" w="4" me="4" />
          Yalnızca iki dakika suruyor!
        </Flex>

        <Button mt="4" variant="solid-brand-cta">
          Ankete katil
        </Button>
      </Box>
    </MBox>
  );
};

export default SurveyPopup;
